import { render, staticRenderFns } from "./WShipments.vue?vue&type=template&id=29d9ee92&scoped=true&"
import script from "./WShipments.vue?vue&type=script&lang=js&"
export * from "./WShipments.vue?vue&type=script&lang=js&"
import style0 from "./WShipments.vue?vue&type=style&index=0&id=29d9ee92&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d9ee92",
  null
  
)

export default component.exports

/* vue-automatic-import-loader */
import autoInstallComponents from "!/Users/waltergammarota/Documents/Trabajo/Orsai/casciari-admin/node_modules/vue-automatic-import-loader/lib/runtime/autoInstallComponents.js"
import WBonosItem from '@/components/WBonosItem.vue'
import WDetalleApuesta from '@/components/WDetalleApuesta.vue'
import WDiscountsDetail from '@/components/WDiscountsDetail.vue'
import WItemVariant from '@/components/WItemVariant.vue'
import WOrderPaymentDetails from '@/components/WOrderPaymentDetails.vue'
import WShipmentCustomValues from '@/components/WShipmentCustomValues.vue'
import WShipmentStatus from '@/components/WShipmentStatus.vue'
autoInstallComponents(component, {WBonosItem,WDetalleApuesta,WDiscountsDetail,WItemVariant,WOrderPaymentDetails,WShipmentCustomValues,WShipmentStatus})
